import React, { useEffect, useState } from 'react';

// Material UI
import SearchIcon from '@mui/icons-material/Search';
import InputAdornment from "@mui/material/InputAdornment";

// Components
import Input from '../input';

const Searchbox = ({ onChange, value, InputProps, interval = 500, ...rest }) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [timerId, setTimerId] = useState();

    useEffect(() => {
        setSearchTerm(value);
    }, [value])

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);

        if(timerId)
            clearTimeout(timerId);

        if(onChange)
            setTimerId(setTimeout(() => onChange(event), interval));
    }

    return (
        <Input
            {...rest}
            value={searchTerm}
            onChange={handleSearch}
            InputProps={
                {
                    endAdornment: (
                        <InputAdornment position="end">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                    ...InputProps,
                }
            }
        />
    )
}

export default Searchbox;